module.exports = __webpack_public_path__ + "img/penta5_icon.565acfd7.png";